(function(){
  // SCROLL-SPY : l'onglet actif suit le scroll
  var sections=[], buttons=[];
  function init(){
    var nav=document.querySelector('.ta-nav-inner');
    if(!nav) return;
    buttons=Array.from(nav.querySelectorAll('.ta-nav-btn'));
    sections=buttons.map(function(b){
      return document.getElementById(b.dataset.target);
    }).filter(Boolean);
    buttons.forEach(function(btn){
      btn.addEventListener('click',function(){
        var el=document.getElementById(btn.dataset.target);
        if(el) el.scrollIntoView({behavior:'smooth'});
      });
    });
    window.addEventListener('scroll',onScroll,{passive:true});
    onScroll();
    // FAQ
    document.querySelectorAll('.ta-faq-btn').forEach(function(btn){
      btn.addEventListener('click',function(){
        btn.closest('.ta-faq-item').classList.toggle('open');
      });
    });
  }
  function onScroll(){
    var scrollY=window.scrollY+120;
    var active=null;
    sections.forEach(function(s){
      if(s && s.offsetTop<=scrollY) active=s;
    });
    buttons.forEach(function(b){
      b.classList.toggle('active', active && b.dataset.target===active.id);
    });
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init);
  } else { init(); }
})();